// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type VerifyGoogleOfflineTokenQueryVariables = Types.Exact<{ [key: string]: never }>;

export type VerifyGoogleOfflineTokenQuery = { __typename?: 'Query' } & Pick<Types.Query, 'verifyGoogleOfflineToken'>;

export const VerifyGoogleOfflineTokenDocument = /*#__PURE__*/ gql`
    query verifyGoogleOfflineToken {
  verifyGoogleOfflineToken
}
    `;

/**
 * __useVerifyGoogleOfflineTokenQuery__
 *
 * To run a query within a React component, call `useVerifyGoogleOfflineTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyGoogleOfflineTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyGoogleOfflineTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useVerifyGoogleOfflineTokenQuery(
  baseOptions?: Apollo.QueryHookOptions<VerifyGoogleOfflineTokenQuery, VerifyGoogleOfflineTokenQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<VerifyGoogleOfflineTokenQuery, VerifyGoogleOfflineTokenQueryVariables>(
    VerifyGoogleOfflineTokenDocument,
    options,
  );
}
export function useVerifyGoogleOfflineTokenLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<VerifyGoogleOfflineTokenQuery, VerifyGoogleOfflineTokenQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<VerifyGoogleOfflineTokenQuery, VerifyGoogleOfflineTokenQueryVariables>(
    VerifyGoogleOfflineTokenDocument,
    options,
  );
}
// @ts-expect-error
export function useVerifyGoogleOfflineTokenSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<VerifyGoogleOfflineTokenQuery, VerifyGoogleOfflineTokenQueryVariables>,
): Apollo.UseSuspenseQueryResult<VerifyGoogleOfflineTokenQuery, VerifyGoogleOfflineTokenQueryVariables>;
export function useVerifyGoogleOfflineTokenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VerifyGoogleOfflineTokenQuery, VerifyGoogleOfflineTokenQueryVariables>,
): Apollo.UseSuspenseQueryResult<VerifyGoogleOfflineTokenQuery | undefined, VerifyGoogleOfflineTokenQueryVariables>;
export function useVerifyGoogleOfflineTokenSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<VerifyGoogleOfflineTokenQuery, VerifyGoogleOfflineTokenQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<VerifyGoogleOfflineTokenQuery, VerifyGoogleOfflineTokenQueryVariables>(
    VerifyGoogleOfflineTokenDocument,
    options,
  );
}
export type VerifyGoogleOfflineTokenQueryHookResult = ReturnType<typeof useVerifyGoogleOfflineTokenQuery>;
export type VerifyGoogleOfflineTokenLazyQueryHookResult = ReturnType<typeof useVerifyGoogleOfflineTokenLazyQuery>;
export type VerifyGoogleOfflineTokenSuspenseQueryHookResult = ReturnType<
  typeof useVerifyGoogleOfflineTokenSuspenseQuery
>;
